export const specialExpressionTypes = {
  '??': 0,
  '&&': 1,
  '||': 2,
  'array': 3,
  'cond': 4,
  '0_def': 5,
  'defined?': 6,
  // '0_defn': 7,
  'block': 7,
  'doseq': 8,
  '0_lambda': 9,
  'for': 10,
  // 'function': 10,
  'if': 11,
  'let': 12,
  'loop': 13,
  'object': 14,
  'recur': 15,
  'switch': 16,
  'throw': 17,
  'try': 18,
  'unless': 19,
} as const

export type SpecialExpressionTypes = typeof specialExpressionTypes
